module.exports = __webpack_public_path__ + "static/slider2-d35fe49e563ddf46a844e98c90b8d070.jpg";